import { all, call, put, takeLatest } from "redux-saga/effects";
import { findAllEmployees } from "../services/employees.service";
import { employeesActions } from "../store/employees.store";

/**
 * システムが全従業員データを取得する
 */
export function* onSystemFetchAllEmployees() {
  const employees = yield call(findAllEmployees);
  yield put(employeesActions.REDUCER_SET_EMPLOYEES(employees));
}

/**
 * 従業員Saga
 */
export function* employeesSagas() {
  yield all([
    yield takeLatest(
      employeesActions.SYSTEM_FETCH_ALL_EMPLOYEES,
      onSystemFetchAllEmployees
    )
  ]);
}
